import React from "react";
import DroppableCell from "./DroppableCell.js";
import { days, coachesForDay } from "./utils.js";

const WeekView = ({
  students,
  coaches,
  selectedDay,
  moveStudent,
  setAddingStudent,
  setDisplayedStudentName,
  setSelectedStudentToAdd,
  onManageStudent,
  hours,
}) => {
  return (
    <>
      <div className="available-coaches-section">
        <h3>Verfügbare Trainer für {selectedDay}</h3>
        <div className="available-coaches-list">
          {coachesForDay(coaches, selectedDay).map((coach) => (
            <div key={coach._id} className="available-coach-item">
              👨‍🏫 {coach.firstName} {coach.lastName}
            </div>
          ))}
        </div>
      </div>

      <div className="schedule-grid">
        {days.map((day) => (
          <div key={day} className="schedule-column">
            <h2>{day}</h2>
            {hours.map((hour) => {
              // Check if any coach is available at this day/hour
              const hasAvailableCoaches = coaches.some(c =>
                Array.isArray(c.availableTimes) &&
                c.availableTimes.some(time => String(time).trim() === `${day} ${hour}`)
              );

              // Skip rendering this hour if no coaches are available
              if (!hasAvailableCoaches) {
                return null;
              }

              return (
                <div key={hour} className="schedule-row">
                  <span className="hour-label">{hour}:00</span>
                  <DroppableCell
                    day={day}
                    hour={hour}
                    coaches={coaches}
                    isWeekView={true}
                    studentsInCell={students.filter((s) => {
                      if (!s) return false;

                      // Check if student has assignments array (new format)
                      if (Array.isArray(s.assignments) && s.assignments.length > 0) {
                        return s.assignments.some((assignment) => {
                          return (
                            String(assignment.day).trim() === String(day).trim() &&
                            Number(assignment.hour) === hour
                          );
                        });
                      }

                      // Fall back to legacy fields for backward compatibility
                      if (String(s.day).trim() !== String(day).trim())
                        return false;
                      const sHour =
                        s.hour === null || s.hour === undefined
                          ? null
                          : Number(s.hour);
                      return sHour === hour;
                    })}
                    moveStudent={moveStudent}
                    setAddingStudent={setAddingStudent}
                    setDisplayedStudentName={setDisplayedStudentName}
                    setSelectedStudentToAdd={setSelectedStudentToAdd}
                    onManageStudent={onManageStudent}
                  />
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </>
  );
};

export default WeekView;
